<template>
  <div class="warp">
    <div class="container">
      <div class="header">
        <div class="titelbox">
          <div class="titelbox-ico" @click="tohome" bucaiji="true">
            <van-icon name="arrow-left" />
          </div>
          <div class="titelbox-tm">考试成绩</div>
          <div class="titelbox-tk"></div>
        </div>
      </div>

      <div class="main">
        <div class="contact" v-if="folderID == '1625'" @click="contactto">
          <img src="../assets/consult.png" alt="" />
        </div>
        <div class="top">
          <div class="chengji">
            <div class="sjname">{{ name }}</div>
            <div class="cj-box">
              <div class="score-outer" :class="outer">
                <div class="score-inside" :class="inside">{{ scoreBox }}分</div>
              </div>
              <div class="cscj">
                <div>考试成绩:{{ scoreBox }}分</div>
                <div>题数：{{ nubs }}题</div>
                <div>满分：{{ points }}分</div>
                <div>耗时：{{ times }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="comment">
          <div class="commentImg">
            <img src="../assets/py.png" alt="" />
          </div>
          <div class="commentText">
            {{ py }}
          </div>
        </div>
        <div class="fstk"><span></span> 题卡 <span></span></div>

        <div class="question" bucaiji="true">
          <div
            class="question-box"
            v-for="(Styleitem, Styleindex) in achievementsBox.StyleArray"
            :key="Styleindex"
          >
            <div class="question-title">
              {{ Styleitem }}
              <span class="zfbox"
                >{{ typeScore.length != 0 ? typeScore[Styleindex] : 1 }}分</span
              >
            </div>
            <div class="question-list">
              <div
                class="question-radius"
                v-show="Styleitem != '综合题' && item.Style == Styleitem"
                :class="
                  topicAnswer[index].ItemName == ''
                    ? 'didanswer'
                    : item.Answer == topicAnswer[index].ItemName
                    ? 'right'
                    : 'wrong'
                "
                v-for="(item, index) in achievementsBox.answerBox"
                :key="'a' + index"
                test_ids="true"
                :test_id="index + 1"
                @click="onAnswer_exam(index)"
                element_namesb="true"
                element_names="题目选择"
                resetlocation="true"
                :newlocation="scoreBox"
              >
                {{ index + 1 }}
              </div>

              <div
                class="question-radius"
                v-show="Styleitem == '综合题' && item.Style == Styleitem"
                :class="
                  topicAnswer[index].ItemName == ''
                    ? 'didanswer'
                    : (item.Answer == topicAnswer[index].ItemName) != ''
                    ? 'right'
                    : 'right'
                "
                v-for="(item, index) in achievementsBox.answerBox"
                :key="'b' + index"
                @click="onAnswer_exam(index)"
                test_ids="true"
                :test_id="index + 1"
                element_namesb="true"
                element_names="题目选择"
                resetlocation="true"
                :newlocation="scoreBox"
              >
                {{ index + 1 }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer">
        <div
          class="dtjx"
          @click="onAnswer_exam"
          name="考试成绩页-答题解析"
          data-sensors-click
          resetlocation="true"
          :newlocation="scoreBox"
        >
          <img src="../assets/jx.png" alt="" /> 答题解析
        </div>
        <div
          class="czbz"
          @click="again"
          name="考试成绩页-重做本章"
          data-sensors-click
        >
          <img src="../assets/cz.png" alt="" /> 重做本章
        </div>
      </div>
    </div>

    <!-- main end -->
  </div>
</template>

<script>
import { urlLink } from "../api/api";
import { mapState } from "vuex";
import {
  Dialog, //确定取消弹出框
} from "vant";
var that;
export default {
  data() {
    return {
      topicAnswer: [], //题目答案储存
      achievementsBox: [], //成绩
      contrastAnswer: [], //正确答案
      scoreBox: 0, //得分
      name: "",
      nubs: "",
      points: 0,
      py: "",
      typeScore: JSON.parse(localStorage.getItem("typeScore")),
      outer: "",
      inside: "",
      folderID: "",
      times: "0时0分0秒",
    };
  },
  computed: {
    ...mapState(["guid"]),
    ...mapState(["userInfo"]),
    ...mapState(["configID"]),
    ...mapState(["agentCode"]),
  },
  async created() {
    // window.document.title = "专业能力测试-考试成绩页";
    this.folderID = localStorage.getItem("folderID");
    var time = localStorage.getItem("HowLongTime");
    this.times = this.formatSeconds(time);
  },
  mounted() {
    that = this;
    this.points = localStorage.getItem("points") || 100; //满分
    this.name = localStorage.getItem("questionsName") || ""; //试卷

    that.topicAnswer = JSON.parse(localStorage.getItem("topicAnswer")); //选中答案
    that.achievementsBox = JSON.parse(localStorage.getItem("achievementsBox"));
    that.nubs = that.achievementsBox.answerBox.length;
    that.contrastAnswer = that.achievementsBox.contrastAnswer;
    // that.calculateScore();
    var topicBox = JSON.parse(
      localStorage.getItem("achievementsBox")
    ).answerBox;
    var scoreBox = 0.0;

    for (let i in topicBox) {
      if (
        that.topicAnswer[i] != undefined &&
        topicBox[i].Answer == that.topicAnswer[i].ItemName
      ) {
        scoreBox = scoreBox + parseFloat(parseFloat(topicBox[i].Score));
      }
    }
    that.scoreBox = scoreBox.toFixed(1);
    localStorage.setItem("scoreBox", that.scoreBox);

    if (that.achievementsBox.accuracy < 30) {
      this.py =
        "您是不是还没有开始学习？或者是不知道从哪里学起？立志从现在做起！";
    } else if (
      that.achievementsBox.accuracy > 29 &&
      that.achievementsBox.accuracy < 60
    ) {
      this.py = "您是不是刚开始学习？还没有全面掌握？多利用碎片时间复习！";
    } else if (
      that.achievementsBox.accuracy > 59 &&
      that.achievementsBox.accuracy < 80
    ) {
      this.py = "很棒，您还需要继续巩固，会掌握得更牢固！";
    } else {
      this.py = "真棒，还可以继续提高，多回顾薄弱点，这样掌握起来更扎实！";
    }

    var outer = ""; //外圈
    var inside = ""; //内圈
    if (scoreBox < 30) {
      outer = "outer30";
      inside = "inside30";
    } else if (scoreBox > 29 && scoreBox < 60) {
      outer = "outer59";
      inside = "inside59";
    } else if (scoreBox > 59 && scoreBox < 80) {
      outer = "outer80";
      inside = "inside80";
    } else {
      outer = "outer100";
      inside = "inside100";
    }
    this.outer = outer;
    this.inside = inside;
  },

  methods: {
    addNum(num1, num2) {
      var sq1, sq2, m;
      try {
        sq1 = num1.toString().split(".")[1].length;
      } catch (e) {
        sq1 = 0;
      }
      try {
        sq2 = num2.toString().split(".")[1].length;
      } catch (e) {
        sq2 = 0;
      }
      m = Math.pow(10, Math.max(sq1, sq2));

      return (num1 * m + num2 * m) / m;
    },
    formatSeconds(value) {
      var secondTime = parseInt(value); // 秒
      var minuteTime = 0; // 分
      var hourTime = 0; // 小时
      if (secondTime > 60) {
        //如果秒数大于60，将秒数转换成整数
        //获取分钟，除以60取整数，得到整数分钟
        minuteTime = parseInt(secondTime / 60);
        //获取秒数，秒数取佘，得到整数秒数
        secondTime = parseInt(secondTime % 60);
        //如果分钟大于60，将分钟转换成小时
        if (minuteTime > 60) {
          //获取小时，获取分钟除以60，得到整数小时
          hourTime = parseInt(minuteTime / 60);
          //获取小时后取佘的分，获取分钟除以60取佘的分
          minuteTime = parseInt(minuteTime % 60);
        }
      }
      if (hourTime > 0) {
        result = "" + parseInt(hourTime) + "小时" + result;
      }
      var result = "" + parseInt(secondTime) + "秒";

      if (minuteTime > 0) {
        result = "" + parseInt(minuteTime) + "分" + result;
      }

      return result;
    },
    contactto() {
      var data = {
        kmEName: localStorage.getItem("kmEName"),
      };
      urlLink(data).then((res) => {
        location.href = res.data.data;
      });
    },
    tohome() {
      that.$router.push({
        path: "/answerView",
      });
    },
    //重做本章
    again() {
      if (!this.guid) {
        this.$dialog
          .alert({
            message: "请先登录后再使用",
          })
          .then(() => {
            this.$router.push("/login");
          });
        return;
      }
      var that = this;
      Dialog.confirm({
        title: "重做将不保存你的做题记录",
        message: "确认重做吗？",
        confirmButtonColor: "#65b2ff",
        confirmButtonText: "确认重做", //改变确认按钮上显示的文字
        cancelButtonText: "取消重做", //改变取消按钮上显示的文字
      })
        .then(() => {
          that.$router.push({
            path: "/examination",
          });

          localStorage.removeItem("wjjachievementsBox");
          localStorage.removeItem("wjjtopicAnswer");
        })
        .catch(() => {
          // on cancel
        });
    },
    onArrowsLeft: function () {
      that.$router.push({
        path: "/answerView",
      });
    },
    onAnswer_exam(indexs) {
      var ids = 0;
      if (indexs >= 0) {
        ids = indexs;
      } else {
        ids = 0;
      }
      localStorage.setItem("index", ids);

      that.$router.push({
        path: "/answerView",
      });
    },
  },
};
</script>

<style scoped>
.fstk {
  font-weight: 400;
  text-align: center;
  color: #1a1a1a;
  font-size: 30px;
  /* line-height: 30px; */
  height: 40px;
  /* background: #ccc; */
  line-height: 40px;
  margin-top: 30px;
}

.fstk span {
  display: inline-block;
  width: 12px;
  height: 12px;
  background: #4bb2ff;
  border-radius: 100%;
  margin: 5px 15px;
}

.comment {
  margin: 0 50px;
  height: 127px;
  background: #ffffff;
  margin-top: 100px;
  border-radius: 25px;
  overflow: hidden;
  box-shadow: 1px 1px 10px 8px rgba(179, 178, 178, 0.23);
}

.comment div {
  float: left;
}

.commentImg {
  padding-top: 28px;
  padding-left: 10px;
  width: 71px;
  height: 71px;
}

.commentText {
  padding-top: 35px;
  padding-left: 15px;
  width: 530px;
}

.comment img {
  width: 71px;
  height: 71px;
}

.zfbox {
  padding-left: 46px;
  font-size: 28px;
  color: #454444;
}

.sjname {
  font-size: 30px;
  padding: 30px;
  padding-bottom: 25px;
  font-weight: 400;
}

.chengji {
  text-align: center;
  width: 602px;
  /*height: 239px;*/
  opacity: 1;
  background: #ffffff;
  border-radius: 50px;
  color: #1a1a1a;
  position: absolute;
  bottom: -72px;
  left: 74px;
  box-shadow: 1px 1px 10px 8px rgba(179, 178, 178, 0.23);
  padding: 10px 5px;
}

.fsindex {
  width: 103px;
  height: 103px;
  border-radius: 50%;
  background: #ffba66;
  line-height: 103px;
  color: #fff;
  float: left;
  margin-left: 146px;
  margin-right: 54px;
}

.cscj {
  font-size: 23px;
  font-weight: 400;
  margin-left: 54px;
  color: #acacac;
}

.cscj div {
  text-align: left;
}

.dtjx {
  float: left;
  line-height: 100px;
  padding-left: 93px;
  font-size: 28px;
}

.czbz {
  float: right;
  line-height: 100px;
  padding-right: 93px;
  font-size: 28px;
}

.question-title {
  margin-top: 35px;
  margin-bottom: 10px;
  color: #000000;
  font-size: 30px;
  font-weight: 400;
}

html {
  margin: 0;
  padding: 0;
}

body {
  background: #eeeeee;
  margin: 0;
  padding: 0;
}

.top {
  width: 100%;
  padding: 5px 0px 0px 0px;
  background: url("../assets/cjbj.png") no-repeat;
  /* background-size: percentage; */
  height: 250px;
  background-size: 100% 100%;
  position: relative;
  /* background-attachment: fixed; */
}

.top-t {
  display: flex;
  justify-content: center;
  /* padding: 10px 20px; */
  font-size: 30px;
  margin: 20px;
  box-sizing: border-box;
  position: relative;
}

.top-t div {
  font-size: 30px;
  color: #ffffff;
}

.top-t-back {
  position: absolute;
  left: 20px;
  top: 0px;
}

.top-t-title {
}

.top-t-box {
  width: 200px;
  height: 200px;
  border-radius: 150px;
  margin: 30px auto;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 10px solid #ffc76a;
}

.top-t-column {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.score {
  text-align: center;
  font-size: 40px;
  color: #ffffff;
}

.score-v {
  text-align: center;
  font-size: 30px;
  color: #f1d096;
}

.when-box {
  display: flex;
  justify-content: center;
  font-size: 30px;
  color: #ffffff;
}

.when-box-r {
  margin-left: 20px;
}

/* main */
.main {
  /* padding: 10px 0px; */
  margin-top: 10px;
  background: #ffffff;
}

.main-nav {
  width: 80%;
  padding: 10px 20px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px dashed #eeeeee;
  box-sizing: border-box;
}

.main-nav-column {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
}

.status {
  width: 40px;
  height: 40px;
  border-radius: 40px;
}

.status-text {
  margin-left: 5px;
}

/* 未答 */
.didanswer {
  /* background: #e8e8e8; */
  border: 1px solid #dadada !important;
  color: #000000 !important;
  background: #ffffff !important;
}

.didanswer-text {
  color: #666;
  font-size: 30px;
  margin-left: 10px;
}

/* 答对 */
.right {
  border: 1px solid #00cd9b !important;
  background: #00cd9b !important;
  color: #ffffff !important;
}

.right-text {
  color: #00cd9b;
}

/* 答错 */
.wrong {
  background: #ffd1d1 !important;
  color: #f54949 !important;
}

.question {
  /* margin: 50px 0px; */
  margin-bottom: 20px;
}

.question-box {
  padding: 5px 30px;
}

.wrong-text {
  color: #ffe3e2;
}

.question-list {
  display: flex;
  flex-wrap: wrap;
}

.question-radius {
  display: flex;
  width: 68px;
  height: 68px;
  border-radius: 1.066667rem;
  margin: 0 0.45rem;
  font-size: 0.4rem;
  margin-top: 0.4rem;
  align-items: center;
  justify-content: center;

  background: #eeeeee;
}

.detail {
  width: 90%;
  height: 80px;
  margin: 0 auto;
  margin-top: 30px;
  font-size: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  background: #ecbb6c;
}

body {
  padding: 0;
  margin: 0;
}

.container {
  height: calc(100vh - 50px);
  background-color: #fff;
  display: flex;
  flex-direction: column;
  /* margin: 100px 0; */
}

.header {
  width: 100%;
  height: 100px;
  background-color: #e77c8e;
  position: fixed;
  z-index: 2;
}

.main {
  width: 100%;
  flex: 1;
  padding: 1.1rem 0;
}

.footer {
  width: 100%;
  height: 100px;
  position: fixed;
  bottom: 0;
  box-shadow: 9px 9px 18px 9px rgba(239, 239, 239, 0.8);
  background: #fff;
  z-index: 2;
}

.footer img {
  width: 39px;
  height: 39px;
  /* vertical-align: middle; */
  float: left;
  padding-top: 28px;
  padding-right: 20px;
}

::-webkit-scrollbar {
  display: none;
  width: 0 !important;
  height: 0 !important;
  -webkit-appearance: none;
  background: transparent;
}

.titelbox {
  height: 100px;
  margin-bottom: 28px;
  line-height: 100px;
  background: #ffffff;
  /* box-shadow: 9px 9px 18px 9px rgba(239, 239, 239, 0.8); */
  padding: 0 33px;
  color: #1a1a1a;
}

.van-icon {
  top: 5px;
  color: #b4b4b4;
}

.nub {
  color: #ffbe6a;
}

.titelbox-ico {
  float: left;
  padding-right: 240px;
  font-size: 50px;
}

.titelbox-tm {
  float: left;
  font-size: 30px;
  padding-left: 10px;
  font-size: 30px;
  color: #000001;
  font-weight: 400;
}

.titelbox-tk {
  float: right;
  font-size: 30px;
}

.score-outer {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 125px;
  height: 125px;
  opacity: 1;
  border-radius: 50%;
  font-weight: 500;
  font-size: 37rpx;
  color: #fefefe;
}

.score-inside {
  width: 102px;
  height: 102px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
}

.cj-box {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 420px;
  margin: 0 auto;
}

/* 外圈 */
.outer59 {
  background: #fff2d6;
}

/* 内圈 */
.inside59 {
  background: #ffd06c;
}

/* 外圈 */
.outer30 {
  background: #ffd1d1;
}

/* 内圈 */
.inside30 {
  background: #ff7c7c;
}

/* 外圈 */
.outer80 {
  background: #fff0de;
}

/* 内圈 */
.inside80 {
  background: #ffba66;
}

/* 外圈 */
.outer100 {
  background: #dffdbb;
}

/* 内圈 */
.inside100 {
  background: #4fcd8d;
}
.warp {
  /* position: absolute; */
  height: 100vh;
  overflow: scroll;
}
.contact {
  width: 90px;
  height: 90px;
  position: absolute;
  bottom: 150px;
  left: 87vw;
  border-radius: 25px;
}
.contact img {
  width: 100%;
  height: 100%;
}
</style>
